import { logOutAction } from 'domain/env/actions';
import Immutable from 'seamless-immutable';
import { ActionType, getType } from 'typesafe-actions';
import { globalAlertsActions, globalAlertsDismissAction } from './actions';
import { TGlobalAlertsAction, TGlobalAlertsState } from './types';

const getGlobalAlertsInitialState = () =>
  Immutable({
    alerts: [],
    error: false,
    isLoaded: false,
    loading: false,
    dismissedIds: [],
  });

const initialState: TGlobalAlertsState = getGlobalAlertsInitialState();

export const reducer = (
  state: TGlobalAlertsState = initialState,
  action: TGlobalAlertsAction | ActionType<typeof logOutAction>
) => {
  switch (action.type) {
    case getType(logOutAction):
      return getGlobalAlertsInitialState();
    case getType(globalAlertsActions.request):
      return state.merge({ error: false, isLoaded: false, loading: true });
    case getType(globalAlertsActions.success):
      return state.merge({
        error: false,
        isLoaded: true,
        loading: false,
        alerts: action.payload.alerts,
      });
    case getType(globalAlertsActions.failure):
      return state.merge({ error: true, isLoaded: false, loading: false });
    case getType(globalAlertsDismissAction):
      return state.merge({
        dismissedIds: state.dismissedIds.asMutable().concat(action.payload.id),
      });

    default:
      return state;
  }
};
